/**
 * @format
 */

import { getVisibleListIds } from '../../../helpers/listVisibility';
import {
  LOAD_LISTS_FAILURE,
  LOAD_LISTS_REQUEST,
  LOAD_LISTS_SUCCESS,
} from '../actions';

export default (state, type, payload) => {
  switch (type) {
    case LOAD_LISTS_REQUEST:
      return Object.assign({}, state, {
        listLoading: true,
      });

    case LOAD_LISTS_SUCCESS: {
      const { workspace_id, lists } = payload;
      const visibleListIds = getVisibleListIds(workspace_id);

      const transformedLists = lists.reduce((acc, list) => {
        if (!acc[workspace_id]) acc[workspace_id] = {};
        acc[workspace_id][list.id] = {
          ...list,
          isVisible: visibleListIds.includes(list.id),
        };
        return acc;
      }, {});

      return {
        ...state,
        listLoading: false,
        lists: {
          ...state.lists,
          ...transformedLists,
        },
      };
    }

    case LOAD_LISTS_FAILURE:
      return Object.assign({}, state, {
        listLoading: false,
      });

    default:
  }
};
